import { Parameters } from '@app/models/Parameters';
import { post, get } from './http.api';
import { ExportExtensionRequest } from '@app/models/export_extention/ExportExtentionRequest';
import { ExportExtensionApiData, ExportExtensionResponse } from '@app/models/export_extention/ExportExtentionResponse';
import {
  ExportExtensionTableData,
  ExportExtensionTableRow,
} from '@app/models/export_extention/ExportExtentionResponse';
import { PCComment } from '@app/models/export/ExportRequest';
import { UploadDocumentResponse } from '@app/models/export/ExportResponse';

export const getExportExtentionTableData = async (parameters: Parameters): Promise<ExportExtensionTableData> => {
  try {
    const { data, status } = await get<any>('/export_extensions', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const exportExtentions: ExportExtensionTableRow[] = data?.data?.map((exportExtention: any) => ({
      code: exportExtention.code,
      //export_code: exportExtention.export_code,
      id: exportExtention.id,
      status: exportExtention.status,
      export_id: exportExtention.export_id,
      request_date: exportExtention.request_date,
      expire_date: exportExtention.expire_date,
    }));

    return {
      status_options: data.status_options,
      data: exportExtentions,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching ExportExtensions:', error);
    throw error;
  }
};
export const getAllExportsExtension = async (): Promise<ExportExtensionResponse> => {
  try {
    const { data, status } = await get<ExportExtensionResponse>('exports', undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getExportExtensionById = async (id: number): Promise<ExportExtensionResponse> => {
  try {
    const { data, status } = await get<ExportExtensionResponse>(`exports/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeExportExtension = async (payload: {
  export_id: number | string;
  status: string;
  customer_id: number | null;
  request_date: string;
  expire_date: string;
}): Promise<ExportExtensionResponse> => {
  try {
    const url = `/exports/${payload.export_id}/export_extensions/create`;
    console.log('storeExportExtension URL:', url);
    console.log('Payload:', payload);
    const response = await post<ExportExtensionResponse>(url, payload);
    return response.data;
  } catch (error: any) {
    console.error('Error storing ExportExtension:', error);
    throw error;
  }
};

export const createExportExtension = async (): Promise<ExportExtensionResponse> => {
  try {
    const { data, status } = await get<ExportExtensionResponse>(
      '/export/${payload.export_id}/export_extensions/create',
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error creating Export Extension:', error);
    throw error;
  }
};

export const showExportExtension = async (id: number) => {
  try {
    const { data, status } = await get<ExportExtensionResponse>(`/export_extensions/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error showing Export Extension:', error);
    throw error;
  }
};

export const editExportExtension = async (id: number) => {
  try {
    const { data, status } = await get<ExportExtensionResponse>(`export_extensions/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error editing Export Extension:', error);
    throw error;
  }
};

export const updateExportExtension = async (id: number, ExportExtensionData: ExportExtensionRequest) => {
  try {
    const response = await post<any>(`export_extensions/${id}/edit`, ExportExtensionData, undefined);
    console.log(`Status: ${response.status}`, `Data:`, response.data);
    return response.data;
  } catch (error: any) {
    console.error('Error updating Export Extension:', error);
    throw error;
  }
};

export interface UploadAdditionalDocumentResponse {
  data: {
    import_additional_documents: {
      name: string;
      file: string;
      document_id: string;
    }[];
    export_extension_documents: any;
  };
  message: string;
}

export const uploadAdditionalDocument = async (
  export_extensions_id: number,
  formData: FormData,
): Promise<UploadAdditionalDocumentResponse | null> => {
  try {
    const { data, status } = await post<UploadAdditionalDocumentResponse>(
      `export_extensions/${export_extensions_id}/upload_additional`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    console.log('Status:', status, 'Data:', data);
    return data;
  } catch (error: any) {
    console.error('Upload error:', error);

    if (error.response) {
      const { status, data } = error.response;
      console.error(`Error ${status}:`, data.errors || data.message);
    } else {
      throw new Error(`Error: ${error.status} - ${error.message}`);
    }

    return null;
  }
};
export const updateExportStatus = async (id: number, action: any) => {
  try {
    const { data, status } = await post<ExportExtensionRequest>(
      `export_extensions/${id}/do_action`,
      action,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const storeExtensionComment = async (id: number, commentData: PCComment) => {
  try {
    const response = await post<any>(`export_extensions/${id}/store_comment`, commentData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateExtensionComment = async (id: number, com_id: number, commentData: PCComment) => {
  try {
    const { data, status } = await post<PCComment>(
      `/export_extensions/${id}/${com_id}/update_comment`,
      commentData,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const generateExtensionCertificate = async (id: number) => {
  try {
    const response = await post<any>(`/export_extensions/${id}/generate_certificate`, undefined, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const uploadExtensionCertifiedDocument = async (
  id: number,
  file: File,
): Promise<UploadDocumentResponse | null> => {
  try {
    const formData = new FormData();

    formData.append('file', file);

    const { data, status } = await post<UploadDocumentResponse>(
      `export_extensions/${id}/upload_certificate`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    console.log('Status:', status, 'Data:', data);

    return data;
  } catch (error: any) {
    console.error('Upload error:', error);
    throw error;
  }
};
